'use strict';
const mmWidgets = require('./mm-widgets');
require('./section-handler-widget');
mmWidgets.fn.localExportWidget = function (localExportModel) {
	return mmWidgets.each(this, function () {
		const widget = this.sectionHandlerWidget();
		localExportModel.addEventListener('result', function (format, title, url) {
			widget.find('[data-mm-role~=data-mm-export-result]').attr({
				download: title,
				href: url
			});
			widget.find('[data-mm-role~=output-url]').val(url);
			widget.find('[data-mm-role~=output-title]').val(title);
		});
		localExportModel.addEventListener('stage', function (stage) {
			const sections = {
				progress: 'inprogress',
				exported: 'done',
				error: 'error'
			};
			widget.removeClass('hidden');
			widget.showSection(sections[stage]);
		});
		widget.on('hide', localExportModel.cleanup);
	});
};
